import { Injectable } from '@angular/core';

@Injectable()
export class SuperAdminService {
  /** Service constructor */
  constructor() {}
}
